import { useQuery } from "@tanstack/react-query";

export type AcademyVenue = {
  id: number;
  title: string;
  address: string | null;
  cityId: number | null;
};

const fetchAcademyVenues = async (): Promise<AcademyVenue[]> => {
  try {
    const baseUrl = process.env.REACT_APP_J_ACADEMY_API_ENDPOINT as string;
    const url = `${baseUrl}venues`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching academy venues:", error);
    return [];
  }
};

const useAcademyVenuesQuery = (enabled = true) => {
  const { data, isLoading, isPending, isError } = useQuery({
    queryKey: ["academy-venues"],
    queryFn: fetchAcademyVenues,
    enabled,
  });

  return { data, isLoading, isPending, isError };
};

export default useAcademyVenuesQuery;
